export default {
  title: 'Send tokens',
  close: 'Close send window',
  currentAccount: 'Sending account: {{source}}',
  browserOnlyMetaMask: 'Browser transfers are signed with MetaMask only. You selected a World App account; return to World App to send from the World App address.',
  sendInWorldApp: 'Send in World App',
  worldAppLinkMissing: 'World App link is not configured.',
  browserMetaMaskOnly: 'Browser transfers are signed with MetaMask only. Connect MetaMask first.',
  noBalances: 'No on-chain balance data is available. Refresh your balances first.',
  usingMetaMask: 'MetaMask will sign this World Chain transfer.',
  token: 'Token',
  availableBalance: 'Available balance',
  max: 'Max',
  recipient: 'Recipient address',
  amount: 'Amount',
  viewTransaction: 'View transaction: {{hash}}',
  submit: 'Send tokens',
  transactionTitle: 'Sending tokens…',
  transactionDescription: 'Sending {{amount}} {{symbol}} to the recipient in World App.',
  confirmed: 'Transaction confirmed. On-chain balances will update.',
} as const;
